module.exports = __webpack_public_path__ + "img/eu2.93d0bc6d.jpg";